import React from 'react';
import { createRoot } from 'react-dom/client';

import App from 'App';
import { ReactQueryProvider } from 'App/components/Query';
import { SocketProvider } from 'App/components/WebSocket';
import { isPartnersEnv } from 'App/constants';
import { GgSecurity } from 'Auth';
import { MobileApplicationChecker } from 'Auth/components/MobileApplicationAvailable';
import GoogleProvider from 'api/google/GoogleProvider';
import withSSL from 'services/withSSL';

import { LicenseInfo } from '@gogame/data-grid';
import { DateProvider } from '@gogame/intl-ts';
import { MessageProvider } from '@gogame/screens';
import './index.css';

import { ThemeSwitcherProvider, ThemeProvider } from '@gogame/components';

import MaintenanceProvider from './App/components/Maintenance';

import { Sentry } from '@gogame/components';
import { DocumentTitleProvider } from '@gogame/screens';

if (withSSL()) {
  throw new Error('should be https');
}

LicenseInfo.setLicenseKey(process.env.REACT_APP_DATAGRID_KEY);
/* eslint-disable no-console */
window.env = {
  ENVIRONMENT: process.env.REACT_APP_ENV,
  REACT_APP_UI_VERSION: process.env.REACT_APP_UI_VERSION,
  REACT_APP_BRANCH: process.env.REACT_APP_BRANCH,
  REACT_APP_BUILD_RELEASE: process.env.REACT_APP_BUILD_RELEASE,
  REACT_APP_SENTRY_BUILD_RELEASE: process.env.REACT_APP_SENTRY_BUILD_RELEASE,
  REACT_APP_API_HOST: process.env.REACT_APP_API_HOST,
  REACT_APP_SOCKETS_HOST: process.env.REACT_APP_SOCKETS_HOST,
};

if (process.env.REACT_APP_SKIP_SOCKETS) {
  console.log('Sockets connections are disabled');
}

createRoot(document.getElementById('root')).render(
  <Sentry.Provider
    enabled={!!process.env.REACT_APP_SENTRY_ENV}
    showErrorDetails={!!process.env.REACT_APP_IS_DEV_ENV}
    dsn={process.env.REACT_APP_SENTRY}
    environment={process.env.REACT_APP_SENTRY_ENV}
    release={process.env.REACT_APP_SENTRY_BUILD_RELEASE}
    sampleRate={parseFloat(process.env.REACT_APP_SENTRY_SAMPLE_RATE)} // % OF ERRORS
    tracesSampleRate={parseFloat(
      process.env.REACT_APP_SENTRY_TRACKES_SAMPLE_RATE // % OF TRANSACTIONS
    )}
    tracePropagationTargets={[/^https:\/\/[\w-]+\.go-game\.io\/gateway/]}
  >
    <DocumentTitleProvider
      prefix={process.env.REACT_APP_DEFAULT_TAB_TITLE_PREFIX}
      title={process.env.REACT_APP_DEFAULT_TAB_TITLE}
    >
      <DateProvider
        locale={process.env.REACT_APP_LOCALE}
        template={'LLL'}
        empty={'—'}
      >
        <ThemeSwitcherProvider>
          <ThemeProvider>
            <MobileApplicationChecker>
              <MessageProvider>
                <ReactQueryProvider>
                  <SocketProvider>
                    <MaintenanceProvider>
                      <GoogleProvider
                        clientId={process.env.REACT_APP_GOOGLE_ID}
                        apiKey={process.env.REACT_APP_GOOGLE_DRIVE_API_KEY}
                      >
                        <GgSecurity isPartner={isPartnersEnv}>
                          <App />
                        </GgSecurity>
                      </GoogleProvider>
                    </MaintenanceProvider>
                  </SocketProvider>
                </ReactQueryProvider>
              </MessageProvider>
            </MobileApplicationChecker>
          </ThemeProvider>
        </ThemeSwitcherProvider>
      </DateProvider>
    </DocumentTitleProvider>
  </Sentry.Provider>
);
